module.exports = __webpack_public_path__ + "static/media/bottom.a0c571e6.png";